import moment from 'moment';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import img from 'assets/images/ShredBox.png';
import { useGetJobUrlNewId, useGetJobUrlNewPdf } from 'hooks/useJobUrlHooks';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Skeleton,
  // Skeleton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Tooltip,
  // Skeleton,
  Typography,
  useTheme
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { gridSpacing } from 'store/constant';
// import AnimateButton from 'ui-component/extended/AnimateButton';
// import { useGetJobUrlPdf } from 'hooks/useJobHooks';
import { useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { roundOffTwo2 } from 'utils/commonUtil';
// import { useEffect } from 'react';
// import ImageEditor from 'views/pages/job/edit/ImageEditor';
const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  margin: '0 auto',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626'
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959'
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343'
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c'
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff'
  }
}));
const HtmlTooltip = styled(({ className, ...props }) => <Tooltip enterTouchDelay={0} {...props} classes={{ popper: className }} arrow />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: '100%',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9'
    }
  })
);
function EnhancedTableHead() {
  const columns = [
    {
      id: 'Image',
      label: 'Image',
      minWidth: 150,
      align: 'center',
      format: (value) => value.toLocaleString('en-US')
    },
    // { id: 'Drive_Number', label: 'Drive Number', minWidth: 150, align: 'center' },

    {
      id: 'Make',
      label: 'Make',
      minWidth: 150,
      align: 'center',
      format: (value) => value.toLocaleString('en-US')
    },
    {
      id: 'Model',
      label: 'Model',
      minWidth: 150,
      align: 'center',
      format: (value) => value.toLocaleString('en-US')
    },
    {
      id: 'Serial',
      label: 'Serial No.',
      minWidth: 150,
      align: 'center',
      format: (value) => value.toLocaleString('en-US')
    }
  ];
  return (
    <TableHead>
      <TableRow>
        {columns?.map((headCell) => (
          <TableCell key={headCell.id} align="center">
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
const JobUrL = () => {
  let { id } = useParams();

  const theme = useTheme();

  const {
    data: jobDetails,
    isPending: isJobDetailsPending,
    error: isJobDetailsError
  } = useGetJobUrlNewId({
    id: id
  });

  const {
    data: jobUrl,
    isLoading: isLoadingPdfUrl,
    isFetching: isFetchingPDF,
    error: isPdfError
  } = useGetJobUrlNewPdf({
    id: id
  });
  const [openModal, setOpenModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    if (!jobUrl) return; // Prevent download if URL is not available
    setOpenModal(true); // Open the modal
  };

  const handleConfirmDownload = () => {
    setIsDownloading(true); // Show loader on "Yes"
    setTimeout(() => {
      window.open(jobUrl, '_blank', 'noopener,noreferrer'); // Open in new tab
      setOpenModal(false); // Close modal
      setIsDownloading(false); // Reset loader after action
    }, 1500); // Simulating a delay for better UX
  };
  const navigate = useNavigate();
  // const [isLoading, setLoading] = useState(false);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 2000);
  // }, []);
  return (
    <>
      <img src={img} className="srd-logo-new" alt="img" />
      <>
        <div className="proceed_to_lgn">
          {' '}
          <Button
            className="job_crtfct_btn"
            sx={{
              zIndex: 11,
              position: 'absolute',
              right: 14,
              top: 18,
              color: '#fff'
            }}
            disableElevation
            size="large"
            type="button"
            variant="contained"
            color="primary"
            onClick={() => {
              navigate('/');
            }}
          >
            {/* {isLoadingPdfUrl || isFetchingPDF ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <SimCardDownloadIcon
              sx={{
                color: '#fff'
              }}
            />
          )} */}
            <KeyboardDoubleArrowRightOutlinedIcon
              sx={{
                color: '#fff'
              }}
            />
            &nbsp; Proceed to Login
          </Button>
        </div>
      </>
      {/* {isLoading ? ( */}
      <>
        {' '}
        <MainCard title={`View Jobs ${id}`} className="shredbox-start shredbox-start2">
          <Grid container spacing={gridSpacing} sx={{ alignContent: 'center' }}>
            <Grid item xs={12}>
              <Typography component="h4" variant="h2" sx={{ mb: 2 }}>
                Job Details
              </Typography>

              <>
                <Button
                  className="job_crtfct_btn"
                  sx={{
                    zIndex: 11,
                    position: 'absolute',
                    right: 14,
                    top: 10,
                    color: '#fff'
                  }}
                  disableElevation
                  size="large"
                  type="button"
                  variant="contained"
                  color="primary"
                  // className="machineViewBtn"
                  onClick={handleDownload}
                  disabled={isLoadingPdfUrl || isFetchingPDF || Boolean(isPdfError)}
                  // style={{ backgroundColor: 'rgb(229 59 59)' }}
                >
                  {isLoadingPdfUrl || isFetchingPDF ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    <SimCardDownloadIcon
                      sx={{
                        color: '#fff'
                      }}
                    />
                  )}
                  &nbsp; Download Certificate
                </Button>
              </>

              <Divider />
              {isJobDetailsPending ? (
                <>
                  {/* <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                    <Box sx={{ mb: 2 }}>
                      <Skeleton variant="text" width="60%" height={30} />
                      <Skeleton variant="text" width="40%" height={20} />
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Skeleton variant="rectangular" width="100%" height={40} />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                      {/* <Skeleton variant="circular" width={40} height={40} /> */}
                  {/* <Skeleton variant="text" width="80%" />
                    </Box>
                  </Paper>{' '} */}
                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      {/* Left Column */}
                      <Grid item xs={12} md={6}>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <Box key={i} sx={{ mb: 1 }}>
                            <Skeleton variant="text" width="40%" />
                            <Skeleton variant="text" width="80%" />
                          </Box>
                        ))}
                      </Grid>

                      {/* Right Column */}
                      <Grid item xs={12} md={6}>
                        {Array.from({ length: 5 }).map((_, i) => (
                          <Box key={i} sx={{ mb: 1 }}>
                            <Skeleton variant="text" width="40%" />
                            <Skeleton variant="text" width="80%" />
                          </Box>
                        ))}
                      </Grid>
                    </Grid>

                    <Skeleton
                      variant="text"
                      width={200}
                      height={30}
                      sx={{
                        mt: 4,
                        mb: 2,
                        mx: 'auto' // centers horizontally like align="center"
                      }}
                    />
                    <Paper>
                      <Table
                        stickyHeader
                        aria-label="sticky table"
                        fullWidth
                        sx={{ ...theme.typography.customInput }}
                        // className="new-table-classs"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <Skeleton variant="rectangular" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                              <Skeleton variant="text" />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Paper>
                  </Box>
                </>
              ) : isJobDetailsError || !jobDetails ? (
                <>
                  {' '}
                  <StyledGridOverlay>
                    <svg style={{ flexShrink: 0 }} width="240" height="200" viewBox="0 0 184 152" aria-hidden focusable="false">
                      <g fill="none" fillRule="evenodd">
                        <g transform="translate(24 31.67)">
                          <ellipse className="ant-empty-img-5" cx="67.797" cy="106.89" rx="67.797" ry="12.668" />
                          <path
                            className="ant-empty-img-1"
                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                          />
                          <path
                            className="ant-empty-img-2"
                            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                          />
                          <path
                            className="ant-empty-img-3"
                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                          />
                        </g>
                        <path
                          className="ant-empty-img-3"
                          d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                        />
                        <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                          <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                          <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                        </g>
                      </g>
                    </svg>
                    <Box sx={{ mb: 4 }}>No data found!</Box>
                  </StyledGridOverlay>
                </>
              ) : (
                <>
                  <div className="shredbox-start">
                    <div className="shredboxmiddlenew">
                      <div className="main-srd-bx-start">
                        <div className="main-srd-bx-start-new">
                          <div className="main-srd-bx-start-new1 main-srd-bx-start-newmachine1">
                            <div className="table-responsive">
                              <table>
                                <tr>
                                  <td>Reference No. :</td>
                                  {/* <td>{jobDetails?.jobId ? jobDetails?.jobId : 'N.A'}</td> */}
                                  <td>{jobDetails?.ticketNo || 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>JOB:</td>
                                  {/* <td>{jobDetails?.jobId ? jobDetails?.jobId : 'N.A'}</td> */}
                                  <td>{jobDetails?.jobId || 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>Name:</td>
                                  <td>{jobDetails?.user?.name || 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>E-mail:</td>
                                  <td>{jobDetails?.user?.email || 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>Address:</td>
                                  <td>{jobDetails?.user?.address || 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>Phone:</td>
                                  <td>{jobDetails?.user?.phone || 'N.A.'}</td>
                                </tr>
                              </table>
                            </div>
                          </div>

                          <div className="main-srd-bx-start-new2 main-srd-bx-start-newmachine">
                            <div className="table-responsive">
                              <table>
                                <tr>
                                  <td>
                                    {' '}
                                    <span>Machine :</span>
                                  </td>
                                  <td>{jobDetails?.machineName ? jobDetails?.machineName : 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>Location:</span>
                                  </td>
                                  <td>{jobDetails?.location ? jobDetails?.location : 'N.A.'}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>Date:</span>{' '}
                                  </td>
                                  <td>
                                    {' '}
                                    {jobDetails?.createdAt ? moment(jobDetails.createdAt).format('Do MMMM YYYY, h:mm a') : 'N.A.'}
                                    {/* {moment(jobDetails?.createdAt).format('Do MMMM YYYY, h:mm a')
                                ? moment(jobDetails?.createdAt).format('Do MMMM YYYY, h:mm a')
                                : 'N.A.'} */}
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <span>Price:</span>
                                  </td>
                                  <td>${jobDetails?.totalPrice ? roundOffTwo2(jobDetails?.totalPrice) : 0}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <span>Tax:</span>
                                  </td>
                                  <td>${jobDetails?.tax ? roundOffTwo2(jobDetails?.tax) : 0}</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider />
                      {/* Drives Processed */}
                      <div className="main-srd-bx-start-new2 main-srd-bx-start-new-drive-process main-srd-bx-start-new3">
                        {/* <h4>Drives Processed</h4> */}

                        <Grid container spacing={gridSpacing} sx={{ alignContent: 'center' }}>
                          <Grid item xs={12}>
                            <h4>Drives Processed</h4>
                          </Grid>
                        </Grid>

                        <div className="table-responsive">
                          <TableContainer>
                            {isJobDetailsPending ? (
                              <Table
                                stickyHeader
                                aria-label="sticky table"
                                fullWidth
                                sx={{ ...theme.typography.customInput }}
                                className="new-table-classs"
                              >
                                <TableBody>
                                  {[1, 2, 3, 4].map((i) => (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                      <TableCell align="center">
                                        <Skeleton variant="text" />
                                      </TableCell>
                                      <TableCell align="center">
                                        <Skeleton variant="text" />
                                      </TableCell>
                                      <TableCell align="center">
                                        <Skeleton variant="text" />
                                      </TableCell>
                                      <TableCell align="center">
                                        <Skeleton variant="text" />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            ) : (
                              <>
                                {jobDetails?.drives.length > 0 ? (
                                  <Table
                                    stickyHeader
                                    aria-label="sticky table"
                                    fullWidth
                                    sx={{ ...theme.typography.customInput }}
                                    className="new-table-classs"
                                  >
                                    <EnhancedTableHead />
                                    <TableBody>
                                      {jobDetails?.drives?.map((row, i) => {
                                        return (
                                          <>
                                            <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                              <TableCell align="center">
                                                <HtmlTooltip
                                                  title={
                                                    <>
                                                      <img
                                                        // src=""
                                                        src={row?.imageURL}
                                                        alt=""
                                                        // width={'100%'}
                                                        // height={100}
                                                        style={{
                                                          borderRadius: 10,
                                                          width: '300px',
                                                          height: '300px'
                                                        }}
                                                      />
                                                    </>
                                                  }
                                                >
                                                  <img
                                                    src={row?.imageURL}
                                                    alt=""
                                                    // width={'100%'}
                                                    // height={100}
                                                    style={{
                                                      borderRadius: 10,
                                                      height: '80px',
                                                      width: '80px',
                                                      justifyContent: 'center',
                                                      alignItems: 'center',
                                                      top: '3px',
                                                      position: 'relative'
                                                    }}
                                                  />
                                                </HtmlTooltip>
                                              </TableCell>

                                              <TableCell align="center">{row?.make ? row?.make.join(', ') : 'N.A.'}</TableCell>
                                              <TableCell align="center">{row?.model ? row?.model.join(', ') : 'N.A.'}</TableCell>
                                              <TableCell align="center">{row?.serialNo ? row?.serialNo.join(', ') : 'N.A.'}</TableCell>
                                            </TableRow>
                                          </>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                ) : (
                                  <StyledGridOverlay>
                                    <svg
                                      style={{ flexShrink: 0 }}
                                      width="240"
                                      height="200"
                                      viewBox="0 0 184 152"
                                      aria-hidden
                                      focusable="false"
                                    >
                                      <g fill="none" fillRule="evenodd">
                                        <g transform="translate(24 31.67)">
                                          <ellipse className="ant-empty-img-5" cx="67.797" cy="106.89" rx="67.797" ry="12.668" />
                                          <path
                                            className="ant-empty-img-1"
                                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                                          />
                                          <path
                                            className="ant-empty-img-2"
                                            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                                          />
                                          <path
                                            className="ant-empty-img-3"
                                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                                          />
                                        </g>
                                        <path
                                          className="ant-empty-img-3"
                                          d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                                        />
                                        <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                                          <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                                          <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                                        </g>
                                      </g>
                                    </svg>
                                    <Box sx={{ mt: 1 }}>No data found!</Box>
                                  </StyledGridOverlay>
                                )}
                              </>
                            )}
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </MainCard>
      </>
      {/* ) : (
        <StyledGridOverlay>
          <svg style={{ flexShrink: 0 }} width="240" height="200" viewBox="0 0 184 152" aria-hidden focusable="false">
            <g fill="none" fillRule="evenodd">
              <g transform="translate(24 31.67)">
                <ellipse className="ant-empty-img-5" cx="67.797" cy="106.89" rx="67.797" ry="12.668" />
                <path
                  className="ant-empty-img-1"
                  d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                />
                <path
                  className="ant-empty-img-2"
                  d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                />
                <path
                  className="ant-empty-img-3"
                  d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                />
              </g>
              <path
                className="ant-empty-img-3"
                d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
              />
              <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
              </g>
            </g>
          </svg>
          <Box sx={{ mt: 1 }}>No data found!</Box>
        </StyledGridOverlay>
      )} */}

      {/* </div>
      </div> */}
      {openModal && (
        <>
          <Dialog
            open={openModal}
            onClose={() => !isDownloading && setOpenModal(false)}
            maxWidth="sm"
            fullWidth={true}
            fullScreen={false}
            className="dlte_file_mdlnw machine-settings"
          >
            <DialogTitle
              id="alert-dialog-title"
              variant="span"
              style={{
                textTransform: 'capitalize'
              }}
            >
              Confirmation!
            </DialogTitle>
            {/* <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
                    <Typography variant="body2">Do you want to download the file?</Typography>
                  </DialogContent> */}
            <DialogContent>
              <DialogContentText id="alert-dialog-description">Do you want to download the certificate?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  onClick={handleConfirmDownload}
                  style={{
                    color: '#fff'
                  }}
                  color="primary"
                  disabled={isDownloading}
                >
                  {isDownloading ? <CircularProgress size={24} /> : 'Yes'}
                </Button>
              </Box>
              <Button variant="outlined" type="reset" color="error" onClick={() => setOpenModal(false)} disabled={isDownloading}>
                No
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default JobUrL;
